export enum BLIND_ACTIONS {
    COMPLETE = 'COMPLETE',
    PARTIAL = 'PARTIAL',
    BLADES = 'BLADES'
}
